function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#business_svg__clip0_1_23)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.985 3.885V1.616a.49.49 0 00-.49-.49H3.902a.49.49 0 00-.49.49v2.27c0 .246.183.449.421.482l-.95 9.56a.491.491 0 00.239.47l2.326 1.374a.49.49 0 00.497 0L8.276 14.4a.489.489 0 00.239-.47l-.956-9.56a.488.488 0 00.426-.484zM4.39 2.106h2.616v1.29H4.39v-1.29zm1.306 12.676l-1.808-1.068.927-9.339h1.76l.933 9.34-1.812 1.067zm-2.939-3.719l-.87-.984L3.354 6.73l.23-2.31L1.139 10a.358.358 0 00.06.38l1.161 1.315a.358.358 0 00.346.113l.147-.033.074-.75-.17.037z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "business_svg__clip0_1_23"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h9v16H0z"
})));
function SvgBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgBusiness;